import { useState } from "react";
import { authenticatedFetch } from '@/services/auth/authenticatedFetch.js';

export const useGenerateFiduciaryReport = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  const generateFiduciaryReport = async (expenseUuids) => {
    setLoading(true);
    setError(null);
    try {
      const response = await authenticatedFetch(`${window.ENV.BACKEND_URL}/api/secured/admin/expense/generateFiduciaryReport`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ expenseReportsUuids: expenseUuids }), // Envoi de la liste d'UUIDs
      });

      if (!response.ok) {
        throw new Error("Failed to generate fiduciary report");
      }

      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      setData({ url, type: blob.type });
      return { url, type: blob.type };
    } catch (err) {
      setError(err.message);
      return null;
    } finally {
      setLoading(false);
    }
  };

  return { generateFiduciaryReport, loading, error, data };
};
